import { render, staticRenderFns } from "./OrgSpecail.vue?vue&type=template&id=5b219a40&scoped=true&"
import script from "./OrgSpecail.vue?vue&type=script&lang=js&"
export * from "./OrgSpecail.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./OrgSpecail.vue?vue&type=style&index=0&id=5b219a40&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b219a40",
  "402d20b5"
  
)

export default component.exports